import React from "react";

interface SuperAdminDashboardCardProps {
  icon: React.ReactNode;
  value: string | number;
  label: string;
  iconBg?: string; // renamed from bg → iconBg
  className?: string;
}

const SuperAdminDashboardCard: React.FC<SuperAdminDashboardCardProps> = ({
  icon,
  value,
  label,
  iconBg = "bg-gray-100",
  className = "",
}) => {
  return (
    <div
      className={`flex w-full items-center gap-4 p-5 rounded-xl bg-white ${className}`}
    >
      {/* ICON CONTAINER */}
      <div
        className={`w-12 h-12 flex items-center justify-center rounded-lg ${iconBg}`}
      >
        {icon}
      </div>

      {/* TEXT */}
      <div className="flex flex-col">
        <span className="text-xl font-semibold text-gray-900 dark:text-gray-100">
          {value}
        </span>
        <span className="text-sm text-gray-600 dark:text-gray-400">
          {label}
        </span>
      </div>
    </div>
  );
};

export default SuperAdminDashboardCard;
